import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.375 16.01a.9.9 0 0 1-.9.9H2.9a.9.9 0 0 1-.9-.9V5.454c0-.651.26-1.276.725-1.736A2.485 2.485 0 0 1 4.475 3H11.9c.656 0 1.286.259 1.75.719.464.46.725 1.085.725 1.736v10.554Zm1.65 0a.9.9 0 0 0 .9.9H20.9a.9.9 0 0 0 .9-.9v-2.292a.9.9 0 0 0-.9-.9h-3.975a.9.9 0 0 0-.9.9v2.291Zm1.65-9.737h-.75a.9.9 0 0 0-.9.9v3.109a.9.9 0 0 0 .9.9h4.057a.818.818 0 0 0 .818-.818 4.079 4.079 0 0 0-1.21-2.892 4.148 4.148 0 0 0-2.915-1.2ZM4.935 18.546c-.24 0-.457.167-.46.409 0 .542.217 1.062.604 1.446a2.071 2.071 0 0 0 2.917 0c.387-.384.604-.904.604-1.447-.003-.24-.22-.409-.46-.409H4.935Zm11.55 0c-.24 0-.457.167-.46.409 0 .542.217 1.062.604 1.446a2.071 2.071 0 0 0 2.917 0c.387-.384.604-.904.604-1.447-.003-.24-.22-.409-.46-.409h-3.205Z" }, null, -1)
  ]))]))
}
export default { render: render }